import { render, staticRenderFns } from "./IssueToFulcrum.vue?vue&type=template&id=331dc813&scoped=true&"
import script from "./IssueToFulcrum.vue?vue&type=script&lang=js&"
export * from "./IssueToFulcrum.vue?vue&type=script&lang=js&"
import style0 from "./IssueToFulcrum.vue?vue&type=style&index=0&id=331dc813&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331dc813",
  null
  
)

export default component.exports